module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAfCAMAAADKrP1yAAAAOVBMVEVHcExfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2iWMncvAAAAEnRSTlMACyQarEh61BTvLeC7V2IF1cicPoIVAAAAcElEQVR42u3Jyw7CQAxDUU+baZLyKPj/P5YAQqiMF4g1d5PIBxzL4wkAZbYVoHqc1zOfk4sCoPOgAeRXEE1D+GVSEE5mF+B0I5cR6IGaR6gd6DlA7fcm/4DanzXbQ+DdDvCHH2FmSmhGA2W5ariuuAGUrhIqtsYwvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_Books.png
// module id = HbIV
// module chunks = 1